import React from "react";
// import { useMsal } from "@azure/msal-react";
// import { InteractionStatus } from "@azure/msal-browser";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  // const { inProgress, instance, accounts } = useMsal();

  // useEffect(() => {
  //   if (inProgress === InteractionStatus.None && accounts.length === 0) {
  //     instance.loginRedirect({
  //       scopes: ["User.Read"],
  //     });
  //   }
  // }, [inProgress, accounts, instance]);

  // if (accounts.length === 0) {
  //   return <div>Redirecting to Microsoft login...</div>;
  // }

  return <>{children}</>;
};

export default ProtectedRoute;
